import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByDateDsc } from './format'

export function newSpendingDemand(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_SPENDING_DEMAND_START", payload: "" })

            console.log("new Spending START", {data})
            const res = await axios.post('/spending_demands/new',{data})
            console.log({res});
            
            if(checkErrorData(res, "CREATE_SPENDING_DEMAND_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_SPENDING_DEMAND", payload: res.data })
				dispatch({ type: "CREATE_SPENDING_DEMAND_FULFILLED", payload: "" })
            }

            // if (!res.data){
            //     dispatch({
            //         type: "CREATE_SPENDING_ERROR",
            //         payload: "Pas de réponse"
            //     })
            // } else if (res.data.error){
            //     dispatch({
            //         type: "CREATE_SPENDING_ERROR",
            //         payload: res.data.error.message
            //     })
            //     console.log("ERROR", res.data.error);
            // } else {
            //     // dispatch(checkError(res.data.error))
                
			// 	dispatch({ type: "NEW_SPENDING", payload: res.data })
			// 	dispatch({ type: "CREATE_SPENDING_FULFILLED", payload: "" })
			// }
        } catch(err) {
            console.log("[ERROR] new spending ", err);
            dispatch({
                type: "CREATE_SPENDING_DEMAND_ERROR",
                payload: err
            })
        }
    }
}
export function fetchUserSpendingsDemand() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_USER_SPENDING_DEMANDS_START", payload: "" })
            console.log("========== fetchUserSpendingsDemand START ==========")
            const res = await axios.get('/spending_demands/')
            console.log("fetchUserSpendingsDemand - res:", res);
            console.log("fetchUserSpendingsDemand - res.data:", res.data);
            console.log("fetchUserSpendingsDemand - res.data type:", Array.isArray(res.data) ? 'array' : typeof res.data);
            console.log("fetchUserSpendingsDemand - res.data length:", Array.isArray(res.data) ? res.data.length : 'not an array');
            
            if(checkErrorData(res, "FETCH_USER_SPENDING_DEMANDS_ERROR", dispatch ) ) {
                console.log("checkErrorData passed, formatting data...");
                const orderedData = orderByDateDsc(res.data, "spending_demand_date");
                console.log("fetchUserSpendingsDemand - orderedData:", orderedData);
                console.log("fetchUserSpendingsDemand - orderedData length:", Array.isArray(orderedData) ? orderedData.length : 'not an array');
                
                const formattedData = formatList(orderedData, "spending_demand_id");
                console.log("fetchUserSpendingsDemand - formattedData:", formattedData);
                console.log("fetchUserSpendingsDemand - formattedData keys:", Object.keys(formattedData));
                console.log("fetchUserSpendingsDemand - formattedData keys length:", Object.keys(formattedData).length);
                
                dispatch({
                    type: "GET_USER_SPENDING_DEMANDS",
                    payload: formattedData
                })
                console.log("Dispatched GET_USER_SPENDING_DEMANDS with payload:", formattedData);
                dispatch({ type: "FETCH_USER_SPENDING_DEMANDS_FULFILLED", payload: "" })
                console.log("========== fetchUserSpendingsDemand END ==========")
            } else {
                console.log("checkErrorData failed - not dispatching");
            }
            
            // if (!res.data.error){
            // } else {
			// 	console.log("ERROR", res.data.error);
			// 	dispatch(checkError(res.data.error))
				
			// }
        } catch(err) {
            console.log("[ERROR] get spending demands list ", err);
            dispatch({
                type: "FETCH_USER_SPENDING_DEMANDS_ERROR",
                payload: err
                
            })
        }
    }
}
export function fetchAdminSpendingsDemand() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_ADMIN_SPENDING_DEMANDS_START", payload: "" })

            console.log("========== fetchAdminSpendingsDemand START ==========")
            console.log("fetch Spending Demand START")
            const res = await axios.get('/spending_demands/admin/get/all')
            console.log("fetchAdminSpendingsDemand - res:", res);
            console.log("fetchAdminSpendingsDemand - res.data:", res.data);
            console.log("fetchAdminSpendingsDemand - res.data type:", Array.isArray(res.data) ? 'array' : typeof res.data);
            console.log("fetchAdminSpendingsDemand - res.data length:", Array.isArray(res.data) ? res.data.length : 'not an array');

            if(checkErrorData(res, "FETCH_ADMIN_SPENDING_DEMANDS_ERROR", dispatch ) ) {
                console.log("checkErrorData passed, formatting data...");
                const orderedData = orderByDateDsc(res.data, "spending_demand_date");
                console.log("fetchAdminSpendingsDemand - orderedData:", orderedData);
                console.log("fetchAdminSpendingsDemand - orderedData length:", Array.isArray(orderedData) ? orderedData.length : 'not an array');
                
                const formattedData = formatList(orderedData, "spending_demand_id");
                console.log("fetchAdminSpendingsDemand - formattedData:", formattedData);
                console.log("fetchAdminSpendingsDemand - formattedData keys:", Object.keys(formattedData));
                console.log("fetchAdminSpendingsDemand - formattedData keys length:", Object.keys(formattedData).length);
                
                dispatch({
                    type: "GET_ADMIN_SPENDING_DEMANDS",
                    payload: formattedData
                })
                console.log("Dispatched GET_ADMIN_SPENDING_DEMANDS with payload:", formattedData);
                dispatch({ type: "FETCH_ADMIN_SPENDING_DEMANDS_FULFILLED", payload: "" })
                console.log("========== fetchAdminSpendingsDemand END ==========")
            } else {
                console.log("checkErrorData failed - not dispatching");
            }
            // if (!res.data.error){
            //     dispatch({
            //         type: "GET_ADMIN_SPENDINGS",
            //         payload: formatList(res.data, "spending_id")
            //     })
            // } else {
			// 	console.log("ERROR", res.data.error);
			// 	dispatch(checkError(res.data.error))
				
			// }
        } catch(err) {
            console.log("[ERROR] get spendings list ", err);
            dispatch({
                type: "FETCH_ADMIN_SPENDING_DEMANDS_ERROR",
                payload: err
                
            })
        }
    }
}

export function fetchSpendingDemandPayments(spendingID) {
    return async function(dispatch){
        try {
            dispatch({ type: "FETCH_SPENDING_DEMAND_PAYMENTS_START", payload: "" })

            console.log("fetch Spending START")
            const res = await axios.post('/spending_demands/payments/get/all',  {data: spendingID})
            console.log({res});

            if(checkErrorData(res, "FETCH_SPENDING_DEMAND_PAYMENTS_ERROR", dispatch ) ) {
                dispatch({
                    type: "GET_SPENDING_DEMAND_PAYMENTS",
                    payload: {spendingID, payments: res.data}
                })
                dispatch({ type: "FETCH_SPENDING_DEMAND_PAYMENTS_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] get spendings list ", err);
            dispatch({
                type: "FETCH_SPENDING_DEMAND_PAYMENTS_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateSpendingDemand(data) {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "UPDATE_SPENDING_DEMAND_START", payload: "" })

            console.log("update Spending START")
            const res = await axios.post("/spending_demands/update", {data})
            console.log({res});

            if(checkErrorData(res, "UPDATE_SPENDING_DEMAND_ERROR", dispatch ) ) {
                let userID = getState().auth.user.id
                dispatch({
                    type: "UPDATE_SPENDING_DEMAND",
                    payload: {data, userID}
                })
                dispatch({ type: "UPDATE_SPENDING_DEMAND_FULFILLED", payload: "" })
            }
           
        } catch(err) {
            console.log("[ERROR] update spending ", err);
            dispatch({
                type: "UPDATE_SPENDING_DEMAND_ERROR",
                payload: err
                
            })
        }
    }
}
export function deleteSpendingDemand(data) {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "DELETE_SPENDING_DEMAND_START", payload: "" })

            console.log("delete Spending START")
            const res = await axios.post("/spending_demands/delete", {data: data.spending_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_SPENDING_DEMAND_ERROR", dispatch ) ) {
                let userID = getState().auth.user.id
                dispatch({
                    type: "DELETE_SPENDING_DEMAND",
                    payload: {data, userID}
                })
                dispatch({ type: "DELETE_SPENDING_DEMAND_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete spending ", err);
            dispatch({
                type: "DELETE_SPENDING_DEMAND_ERROR",
                payload: err
            })
        }
    }
}
export function updateFetchSpendingDemand(spendingID) {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "UPDATE_FETCH_SPENDING_DEMAND_START", payload: "" })

            console.log("update Spending START")
            const res = await axios.post("/spending_demands/single", {spendingID})
            console.log({res});

            let userID = getState().auth.user.id
            
            if(checkErrorData(res, "UPDATE_FETCH_SPENDING_DEMAND_ERROR", dispatch ) ) {
                dispatch({
                    type: "UPDATE_FETCH_SPENDING_DEMAND",
                    payload: {data: res.data, userID}
                })
                dispatch({ type: "UPDATE_FETCH_SPENDING_DEMAND_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] update spending ", err);
            dispatch({
                type: "UPDATE_FETCH_SPENDING_DEMAND_ERROR",
                payload: err
                
            })
        }
    }
}

export function updateUserSpendingDemand(data) {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "UPDATE_SPENDING_DEMAND_START", payload: "" })

            console.log("update Spending START")
            const res = await axios.post("/spending_demands/user/update", {data})
            console.log({res});
            
            if(checkErrorData(res, "UPDATE_SPENDING_DEMAND_ERROR", dispatch ) ) {
                let userID = getState().auth.user.id
                dispatch({
                    type: "UPDATE_SPENDING_DEMAND",
                    payload: {data, userID}
                })
                dispatch({ type: "UPDATE_SPENDING_DEMAND_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] update spending ", err);
            dispatch({
                type: "UPDATE_SPENDING_DEMAND_ERROR",
                payload: err
                
            })
        }
    }
}

export function fetchSingleSpendingDemand(spendingDemandId) {
    return async function(dispatch){
        try{
            console.log("fetch Single Spending Demand START", {spendingDemandId})
            const res = await axios.post('/spending_demands/single', {spendingID: spendingDemandId})
            console.log({res});
            
            if(checkErrorData(res, "FETCH_SINGLE_SPENDING_DEMAND_ERROR", dispatch ) ) {
                return res.data
            }
            return null
        } catch(err) {
            console.log("[ERROR] fetch single spending demand ", err);
            return null
        }
    }
}
